import "./PromoBubble.scss";

export interface PromoBubbleProps {
  /** 气泡文案。空串/空白会直接返回 null —— 消费方不需要在外面再判一次 */
  text?: string | null;
  /** 追加到根节点的 class，便于消费方做位置微调 */
  className?: string;
  /**
   * 气泡相对锚点的方向，默认 `up`（气泡在按钮上方、三角朝下）。
   * `down` = 气泡挂在按钮下方、三角朝上 —— 按钮本身贴着页面顶部（如顶栏里的注册按钮）时用它，
   * 否则气泡会被顶出可视区。
   */
  direction?: "up" | "down";
}

/**
 * 注册按钮旁的首充优惠气泡。金色渐变 + 三角指向锚点，定位 absolute；
 * 需要由消费方在父容器上 position: relative。
 */
export function PromoBubble({
  text,
  className = "",
  direction = "up",
}: PromoBubbleProps) {
  const trimmed = text?.trim();
  if (!trimmed) return null;
  return (
    <span
      className={`promo-bubble${direction === "down" ? " promo-bubble--down" : ""} ${className}`.trim()}
      role="note"
      aria-hidden="true"
    >
      <span className="promo-bubble__text">{trimmed}</span>
    </span>
  );
}

export default PromoBubble;
